import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ProductOffers } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const StoreCategoriesContainer = (_param)=>{
    var { storeCategories , fallbackImage  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "storeCategories",
        "fallbackImage"
    ]);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('stores.page.details.productGroups.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(ProductOffers, swcHelpers.extends({}, rest, {
        offers: storeCategories,
        fallbackImage: fallbackImage,
        labels: labels
    }));
};
var StoreCategories = StoreCategoriesContainer;

export { StoreCategories as default };
//# sourceMappingURL=StoreCategoriesContainer.js.map
